import React from 'react';
import { Link } from 'react-router-dom';

export interface NotFoundPageProps {
  title?: string;
  description?: string;
  /** When true, show a secondary link to /trees. */
  showMyTreesLink?: boolean;
  /** Optional block below the buttons (e.g. sign-in hint when My trees is hidden). */
  footer?: React.ReactNode;
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({
  title = 'Page not found',
  description =
    "We couldn't find what you're looking for. The link may be wrong, or the page may have been removed.",
  showMyTreesLink = true,
  footer,
}) => {
  return (
    <div className="private-access-denied">
      <div className="private-access-denied-content">
        <h1>{title}</h1>
        <p>{description}</p>
        <div className="private-access-denied-actions">
          <Link to="/" className="btn btn-primary">
            Go to home
          </Link>
          {showMyTreesLink ? (
            <Link to="/trees" className="btn btn-secondary">
              My trees
            </Link>
          ) : null}
        </div>
        {footer}
      </div>
    </div>
  );
};
